import React from "react";
import { Typography } from "antd";
import "./HeaderComponentWithTitleAndLogo.scss";

const { Title, Text } = Typography;

const HeaderComponentWithTitleAndLogo = ({ 
    logoSrc = "/websiteLogo.png", 
    logoAlt = "Logo", 
    title = "Sign In", 
    subtitle 
}) => {
    return (
        <div className="header-component">
            {/* <img
                src={logoSrc}
                alt={logoAlt}
                className="header-component__logo-img"
            /> */}
            <Title level={3} className="header-component__title">
                {title}
            </Title>
            {subtitle && (
                <Text type="secondary" className="header-component__subtitle">
                    {subtitle}
                </Text>
            )}
        </div>
    );
};

export default HeaderComponentWithTitleAndLogo;
